import { ItemLimit } from "@glamcorner/gc-types/lib/subscription";
import React from "react";

import ItemsPerMonth from "../../components/ItemsPerMonth";

import "./itemsPerMonthContainer.scss";


type ItemsPerMonthContainerType = {
  itemLimits: ItemLimit[];
  selected: ItemLimit;
  onClick: (items: ItemLimit) => void;
};

export const ItemsPerMonthContainer: React.FC<ItemsPerMonthContainerType> = ({ itemLimits, selected, onClick }) => {
  return (
    <div className="choosePlan-ItemsPerMonthContainer__wrapper">
      <p>
        Step 1: <br />
        Select number of items per month
      </p>
      <ItemsPerMonth itemLimits={itemLimits} selected={selected} onClick={onClick} />
    </div>
  );
};
